import { getAppInstance } from 'common/browser';
import { getDcfExperience, getPayloadTypeIndicatorCheckout } from 'communicator/store/selectors';
import endpoints from 'communicator/utils/endpoints';
import fetchReq from 'communicator/utils/fetch';
import { EnrollCardRequest, EnrollCardResponse } from 'types/api/enroll-card';
import { DpaTransactionOptions } from 'types/emvco';
import { FetchResponse } from 'types/fetch';

type FetchEnrollCardOptions = {
  accessToken?: string;
  apikey: string;
  dpaTransactionOptions?: DpaTransactionOptions;
  encryptedBillingAddress?: string;
  encryptedCard: string;
  encryptedConsumer: string | null;
  intentId?: string;
  srcCorrelationId?: string;
  srcDpaId?: string;
};

export default function fetchEnrollCard({
  accessToken,
  apikey,
  dpaTransactionOptions,
  encryptedBillingAddress,
  encryptedCard,
  encryptedConsumer,
  intentId,
  srcCorrelationId,
  srcDpaId
}: FetchEnrollCardOptions): FetchResponse<EnrollCardResponse> {
  const enrollCardEndpoint = accessToken ? endpoints.enrollCardXo : endpoints.enrollCard;
  const dcfExperience = getDcfExperience();
  let url = `${enrollCardEndpoint}?apikey=${apikey}`;

  if (intentId) {
    url += `&intentId=${intentId}`;
  }

  if (dcfExperience) {
    url += `&dcfExperience=${dcfExperience}`;
  }

  const headers: Record<string, string> = {};

  if (accessToken) {
    headers.access_token = accessToken;
  }

  const body: EnrollCardRequest = {
    appInstance: {
      userAgent: getAppInstance()
    },
    encryptedBillingAddress,
    encryptedCard,
    payloadTypeIndicatorCheckout: getPayloadTypeIndicatorCheckout(),
    srcClientId: apikey,
    srcCorrelationId
  };

  if (encryptedConsumer) {
    body.encryptedConsumer = encryptedConsumer;
  }

  if (encryptedBillingAddress) {
    body.encryptedBillingAddress = encryptedBillingAddress;
  }

  if (srcDpaId) {
    body.srcDpaId = srcDpaId;
  }

  if (dpaTransactionOptions) {
    body.dpaTransactionOptions = dpaTransactionOptions;
  }

  return fetchReq({
    body,
    headers,
    mark: 'enroll_card',
    method: 'POST',
    url
  });
}
